import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import ContentCarouselTripleDotted from 'rebook/apps/base/components/ContentCarouselTripleDotted';
import DashboardBanner from 'rebook/apps/dashboard/components/DashboardBanner';
import DashboardBannerEmpty from 'rebook/apps/dashboard/components/DashboardBannerEmpty';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';


const DashboardBannerList = ({ banners }) => (
  <ContentCarouselTripleDotted>
    {banners && banners.length !== 0
      ? (
        banners.map((banner) => (
          <DashboardBanner
            key={banner.id}
            {...banner} />
        ))
      )
      : <DashboardBannerEmpty />
    }
  </ContentCarouselTripleDotted>
);

class DashboardBannerListBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;
    this.state = {
      block,
      blockId,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchBannerList();
  }

  fetchBannerList() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = this.state.block.resource_uri;
    this.props.DashboardBlockListActions.fetchDashboardBlock(url)
      .then(
        ({ data, dispatch }) => {
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                banners: data.objects,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard banner list due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  render() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;
    const banners = get(dashboardBlockList[blockId], 'banners', []);
    return (
      <DashboardBannerList banners={banners} />
    );
  };
};

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardBannerListBlock.propTypes = {
  block: PropTypes.shape({
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBannerListBlock);
